import { useContext, useState } from 'react';
import { GlobalContext } from '../context/GlobalContext';

import Login from './Login/Login';
import LoginOTP from './LoginOTP/LoginOTP';
import Success from './Success/Success';
import Loader from '../components/Loader/Loader';

function Pages() {
    const { state }: any = useContext(GlobalContext);
    const [success, setSuccess] = useState(false);

    return (
        <>
            <Loader />
            {success ? <Success rtl={state.rtl} /> : (
                state.loginActive ? (
                    <Login setSuccess={setSuccess} />
                ) : (
                    <LoginOTP setSuccess={setSuccess} />
                )
            )}
        </>
    )
}

export default Pages